import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
	BettoFieldLabel,
	BettoFieldRoot,
} from "../../shared/bettoPaymentFieldStyles";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

const Input = styled.input`
	height: 44px;
	width: 100%;
	padding: 0 14px;
	border-radius: 8px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	font-weight: 400;
	line-height: 1.2;
	outline: none;
	box-sizing: border-box;

	&:focus {
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
	}

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	&[type="number"] {
		-moz-appearance: textfield;
	}
`;

export const BettoStakeInput = ({
	autoFocus,
	onChange,
	label,
	"data-testid": dataTestId,
	"label-data-testid": labelDataTestId,
}) => {
	const [value, setValue] = useState("");

	const handleChange = (event) => {
		setValue(event.target.value);
		onChange(event);
	};

	return (
		<BettoFieldRoot>
			<BettoFieldLabel data-testid={labelDataTestId}>{label}</BettoFieldLabel>
			<Input
				data-testid={dataTestId}
				type="text"
				inputMode="decimal"
				autoFocus={autoFocus}
				value={value}
				onChange={handleChange}
				onWheel={(event) => event.target.blur()}
			/>
		</BettoFieldRoot>
	);
};

BettoStakeInput.propTypes = {
	autoFocus: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	"data-testid": PropTypes.string,
	"label-data-testid": PropTypes.string,
};

BettoStakeInput.defaultProps = {
	autoFocus: true,
	"data-testid": undefined,
	"label-data-testid": undefined,
};
